import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api } from "../utils/api";

const AdminContext = createContext(null);

export function AdminProvider({ children }) {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    const checkAuth = useCallback(async () => {
        const token = localStorage.getItem("lumis_admin_token");
        if (!token) { setLoading(false); return; }
        try {
            const res = await api.getMe();
            setAdmin(res.admin);
        } catch {
            localStorage.removeItem("lumis_admin_token");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { checkAuth(); }, [checkAuth]);

    const login = async (email, password) => {
        const res = await api.login({ email, password });
        localStorage.setItem("lumis_admin_token", res.token);
        setAdmin(res.admin);
        return res;
    };

    const logout = () => {
        localStorage.removeItem("lumis_admin_token");
        setAdmin(null);
    };

    return (
        <AdminContext.Provider value={{ admin, loading, login, logout }}>
            {children}
        </AdminContext.Provider>
    );
}

export function useAdmin() {
    return useContext(AdminContext);
}
